/**
 * Generate unique UUID
 * default length is 2
 *
 * @param {Number} length
 * @return {String} Return new UUID for bet
 */
function makeRequestUuid(length) {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  let uuid;
  switch (length) {
    case 2: {
      uuid = `${s4()}${s4()}`;
      break;
    }
    default: {
      uuid = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
    }
  }
  return uuid;
}

/**
 * Prepare bets for  ticket
 *
 * @param {Array} bets
 * @returns {Array} Returns new bets with
 * game name, idBet, outcomeOdd, outcomeType, betSpecialValue.
 */
function prepareBets(bets) {
  const newbBets = [];
  for (let i = 0; i < bets.length; i += 1) {
    newbBets.push({
      gameName: `${window.sevenConfig.product.id}`,
      idBet: bets[i].idMb,
      mboOddValue: bets[i].mboOddValue,
      outcomeOdd: bets[i].mboOddValue,
      outcomeType: bets[i].mboType,
      betSpecialValue: bets[i].mbSpecialValue,
      ticketBetWay: 0,

    });
  }
  return newbBets;
}

/**
 * Format ticket for payin
 *
 * @param {number} stake
 * @param {Object} state
 * @returns {Object} Return ticket that contains array of bets, payin, ticket type id, product id...
 */
function formatter(stake, state) {
  const bets = prepareBets(state.bets);
  const ticket = {
    bets,
    payin: +stake,
    product: `${window.sevenConfig.product.id}`,
    ticketComment: '',
    ticketCombinationGroups: [],
    ticketOddsOptions: 2,
    ticketType: state.betTypes[state.activeBetType].id,
  };
  return ticket;
}
export default {
  formatter,
  makeRequestUuid,
};
